// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Auth from "../../bundles/Auth/Auth.res.js";
import * as React from "react";
import * as Scalar from "../../core/Scalar.res.js";
import * as Placeholder from "../../resources/layout-and-structure/Placeholder.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as CatalogVariantPage from "./CatalogVariantPage.res.js";
import * as CatalogVariant__Config from "./CatalogVariant__Config.res.js";
import * as CatalogVariant__Queries from "./CatalogVariant__Queries.res.js";

function CatalogVariantContainer(props) {
  let cku = props.cku;
  let match = CatalogVariant__Queries.VariantQuery.useLazy(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  let executeVariantQuery = match[0];
  let match$1 = CatalogVariant__Queries.VariantShopsQuery.useLazy(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  let executeShopsQuery = match$1[0];
  let match$2 = CatalogVariant__Queries.PricesQuery.useLazy(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  let executePricesQuery = match$2[0];
  let activeShop = Auth.useActiveShop();
  React.useEffect(() => {
    executeVariantQuery(undefined, undefined, CatalogVariant__Queries.VariantQuery.makeVariables(Scalar.CKU.serialize(cku), CatalogVariant__Config.makeVariantFilterBy(activeShop, undefined), undefined));
    executeShopsQuery(undefined, undefined, CatalogVariant__Queries.VariantShopsQuery.makeVariables(Scalar.CKU.serialize(cku), undefined));
    executePricesQuery(undefined, undefined, CatalogVariant__Queries.PricesQuery.makeVariables());
  }, [Stdlib_Option.map(activeShop, param => param.id)]);
  let results = CatalogVariant__Config.use(match[1], match$1[1], match$2[1]);
  if (typeof results !== "object") {
    if (results === "Error") {
      return JsxRuntime.jsx(Placeholder.make, {
        status: "Error"
      });
    } else {
      return JsxRuntime.jsx(Placeholder.make, {
        status: "Loading"
      });
    }
  }
  let match$3 = results._0;
  return JsxRuntime.jsx(CatalogVariantPage.make, {
    fromLabelEditSettingsRedirected: props.fromLabelEditSettingsRedirected,
    cku: cku,
    variantShopIds: match$3.variantShopIds,
    shopsProduct: match$3.shopsProduct,
    shopsVariant: match$3.shopsVariant,
    shopsVariantStock: match$3.shopsVariantStock,
    shopsVariantPurchasePrice: match$3.shopsVariantPurchasePrice,
    shopsVariantRetailPrices: match$3.shopsVariantRetailPrices
  });
}

let make = React.memo(CatalogVariantContainer);

let Config;

let VariantQuery;

let VariantShopsQuery;

let PricesQuery;

export {
  Config,
  VariantQuery,
  VariantShopsQuery,
  PricesQuery,
  make,
}
/* make Not a pure module */
